import styled from '@emotion/styled'
import React from 'react'

import NameBadge, { INITIALS_CIRCLE_COLORS } from './NameBadge'

const Badge = styled(NameBadge)`
	height: 32px;
	width: 32px;
	border-radius: ${({ theme }) => theme.borderRadiuses.md};
	flex-shrink: 0;
`

type Props = {
	name: string
}

function TemplateInitialsSquare({ name, ...restProps }: Props) {
	const colorIndex = name.split('').reduce((sum, val) => sum + val.charCodeAt(0), 0) % INITIALS_CIRCLE_COLORS.length

	return <Badge textForInitials={name} colorIndex={colorIndex} {...restProps} />
}

export default React.memo(TemplateInitialsSquare)
